import { render, staticRenderFns } from "./posWarnTable.vue?vue&type=template&id=ed9e55fa&scoped=true&"
import script from "./posWarnTable.vue?vue&type=script&lang=js&"
export * from "./posWarnTable.vue?vue&type=script&lang=js&"
import style0 from "./posWarnTable.vue?vue&type=style&index=0&id=ed9e55fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9e55fa",
  null
  
)

export default component.exports